import React, { useContext } from 'react';
import * as Yup from "yup";
import { useFormik } from "formik";
import { getDeviceInfo, getGroupAuthId } from '../utils';
import { LoginContext } from '../../../Contexts/LoginContext';
import Constants from '../../../Constants/constants';
import config from '../../../config';
import EndPoints from '../../../Constants/EndPoints';
import { toast } from 'react-toastify';
import { POST } from '../../../Services/api_services';

const ProfileDescriptionPopup = ({ data, onClose }) => {
  const { loginDetail, logout } = useContext(LoginContext);

  const formik = useFormik({
    initialValues: {
      moreInfo: data?.content ? data?.content : "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      moreInfo: Yup.string(),
    }),
    onSubmit: async (values, { setSubmitting }) => {
        const { descriptionEdit = "N", descriptionPopupConfirm = "N" } = values;
      
        await apiCallEditProfile(values, descriptionEdit, descriptionPopupConfirm);
        setSubmitting(false);
      },
  });

  const onInfoChange = (e) => {
    let text = e.target.value ?? "";
    text = text.replace(/  +/g, " ");
    formik.setFieldValue('moreInfo', text);
  };

  const apiCallEditProfile = async (values, descriptionEdit = "N", descriptionPopupConfirm = "N") => {
    let request = {
      email: loginDetail()[0],
      userId: loginDetail()[1],
      more_info: values.moreInfo,
      ...(values.moreInfo !== "" && { descriptionrequesttypeid: 43 }),
      requestfulfilledfrom: getDeviceInfo(),
      requestfulfilledvia: "Myprofile",
      recieverprofileid: getGroupAuthId(),
      loginFrom: localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
      editFrom: "Myprofile",
      // descriptionEdit: "N", 
      descriptionEdit,
      descriptionPopupConfirm,
    };

    let { statusCode, data } = await POST(
      `${config.api.API_URL}${EndPoints.editdescriptioninfosaveUrl()}`,
      request
    );

    if (statusCode === 200) {
      if (data.data.status === "SUCCESS") {
        onClose();
        toast.success(
          <div className='flex items-center'>
            {"Detail added Successfully. The added detail will reflect in your profile after verification by Kalyan Matrimony."}
          </div>
        );
      }
    } else if (statusCode === 401) {
      logout();
    }
  };

  const handleYesClick = () => {
    const isEditing = formik.values.moreInfo !== data?.content;
    const descriptionEdit = isEditing ? "Y" : "N";
    const descriptionPopupConfirm = isEditing ? "N" : "Y";
  
    // Pass the values to formik and let it handle the API call
    formik.setFieldValue("descriptionEdit", descriptionEdit);
    formik.setFieldValue("descriptionPopupConfirm", descriptionPopupConfirm);
    formik.handleSubmit();
  };
  
  const handleNoClick = () => {
    // Clear the description and let formik handle the API call
    formik.setFieldValue("moreInfo", "");
    formik.setFieldValue("descriptionEdit", "Y");
    formik.setFieldValue("descriptionPopupConfirm", "N");
    formik.handleSubmit();
  };

  return (
    <div>
      <div className="flex justify-center bg-opacityblack items-end md:items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto md:my-6 mx-auto">
          <div className="bg-white rounded-tl-[3rem] rounded-tr-[3rem] md:rounded-[1rem] p-4">
            <div className="pt-5 pb-4 p-4 md:p-6 md:w-[38rem] w-[22rem] rounded-2xl">
              <div className="space-y-3 items-start">
                <p className="text-[#D10A11] flex font-bold text-[20px] md:text-[20px] lg:text-[22px]">
                  Confirm Your Profile Description
                </p>
                <p className="text-[12px] md:text-[12px] lg:text-[14px] font-Poppins-Regular">
                  Based on your profile details, we suggest the following description. Stand out and attract your perfect match with a well-written profile!
                </p>
                <form onSubmit={formik.handleSubmit}>
                  <div className="flex justify-center">
                    <textarea
                      rows="5"
                      id="description"
                      name="moreInfo"
                      value={formik.values.moreInfo.replace(/\s\s+/g, ' ')}
                      onChange={onInfoChange}
                      placeholder={"Add Description"}
                      className="form-control shadow-sm bg-[#FFFFFF] text-[#585858] text-[13px] focus:outline-none rounded-[7px] focus:ring-[#2D2C6F] border-[1px] border-[#606060] py-2 px-1 md:py-2 md:px-2 w-full block placeholder:text-[#585858] placeholder:opacity-50"
                    />
                  </div>
                </form>

                <div className="">
                <p className='text-[#585858] text-[10px] md:text-[12px] lg:text-[14px] font-Poppins-Regular'>
                  *You can also type your own by clicking the description box.
                </p>
                <p className='text-[#585858] text-[10px] md:text-[12px] lg:text-[14px] font-Poppins-Regular'>*If you confirm, this will be saved as your profile description.
                </p>
                <p className='text-[#585858] text-[10px] md:text-[12px] lg:text-[14px] font-Poppins-Regular'>*If no action is taken, the suggested description will automatically be saved to your profile in 15 days.
                </p>
                </div>

                <div className='flex justify-center px-4 gap-10'>
                  <button
                    type="button"
                    onClick={handleYesClick}
                    className='bg-[#D10A11] cursor-pointer text-[#12px] font-Poppins-SemiBold text-[#FFFFFF] w-[8rem] py-2 rounded-md'
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    onClick={handleNoClick}
                    className='cursor-pointer text-[#12px] font-Poppins-SemiBold w-[8rem] py-2 rounded-md border border-gray-600'
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDescriptionPopup;
